import React from 'react';
import './ProctorBypass.css';

const ProctorBypass = () => {
  return (
    <div className="proctor-bypass-page">
      {/* Убрал background и orbs - теперь используем частицы модалки */}

      <div className="container">
        {/* Header */}
        <header className="header">
          <h1>Module 1: Proctor Bypass System</h1>
          <p className="subtitle">Complete Invisibility Layer Architecture</p>
        </header>

        {/* Architecture Section */}
        <section className="architecture-section">
          <h2 className="section-title">How It Works</h2>
          
          <div className="architecture-diagram">
            {/* Step 1: You take screenshot */}
            <div className="arch-layer">
              <div className="layer-icon">📸</div>
              <h3 className="layer-title">Step 1: Take Screenshot/Screencast</h3>
              <p className="layer-desc">Press hotkey to capture the exam question or record screen. Completely invisible to proctor.</p>
              <span className="layer-badge">Your Action</span>
            </div>

            <div className="arrow-connector">
              <span className="arrow-label">Send</span>
              <div className="arrow-line"></div>
            </div>

            {/* Step 2: Send to helper */}
            <div className="arch-layer success">
              <div className="layer-icon">🤖</div>
              <h3 className="layer-title">Step 2: Get Help</h3>
              <p className="layer-desc">Send to friend via Telegram/Discord OR paste directly to ChatGPT/Claude</p>
              <span className="layer-badge">Helper/AI</span>
            </div>

            <div className="arrow-connector">
              <span className="arrow-label">Answer</span>
              <div className="arrow-line"></div>
            </div>

            {/* Step 3: Receive answer */}
            <div className="arch-layer">
              <div className="layer-icon">✅</div>
              <h3 className="layer-title">Step 3: Receive Answer</h3>
              <p className="layer-desc">Get response in protected messenger window. Type answer in exam.</p>
              <span className="layer-badge">Complete</span>
            </div>
          </div>
        </section>

        {/* Split View Section */}
        <section className="split-view-section">
          <h2 className="section-title">What Proctor Sees vs Reality</h2>
          
          <div className="split-container">
            {/* Proctor View */}
            <div className="view-panel proctor-view">
              <div className="view-header">
                <span className="view-icon">👁️</span>
                <h3 className="view-title">Proctor's View</h3>
                <span className="view-status status-deceived">Deceived</span>
              </div>
              <div className="view-content">
                <div className="screen-mockup">
                  <div className="window-bar">
                    <span className="window-dot"></span>
                    <span className="window-dot"></span>
                    <span className="window-dot"></span>
                  </div>
                  <div className="exam-content">
                    <div className="exam-title">Mathematics Exam - Question 5</div>
                    <div className="exam-text">Student appears focused on exam. No suspicious activity detected.</div>
                  </div>
                </div>

                <div className="activity-list">
                  <div className="activity-item">
                    <span className="activity-icon">🎯</span>
                    <div className="activity-text">
                      <div className="activity-label">Focus Status</div>
                      <div className="activity-status">Locked on exam</div>
                    </div>
                  </div>
                  <div className="activity-item">
                    <span className="activity-icon">📸</span>
                    <div className="activity-text">
                      <div className="activity-label">Screen Capture & Recording</div>
                      <div className="activity-status">Only exam visible</div>
                    </div>
                  </div>
                  <div className="activity-item">
                    <span className="activity-icon">📱</span>
                    <div className="activity-text">
                      <div className="activity-label">Applications</div>
                      <div className="activity-status">No external apps</div>
                    </div>
                  </div>
                  <div className="activity-item">
                    <span className="activity-icon">🖱️</span>
                    <div className="activity-text">
                      <div className="activity-label">Mouse Activity</div>
                      <div className="activity-status">Within exam area</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Reality View */}
            <div className="view-panel reality-view">
              <div className="view-header">
                <span className="view-icon">✨</span>
                <h3 className="view-title">Actual Reality</h3>
                <span className="view-status status-active">Fully Active</span>
              </div>
              <div className="view-content">
                <div className="screen-mockup multi-window">
                  <div className="window-bar">
                    <span className="window-dot"></span>
                    <span className="window-dot"></span>
                    <span className="window-dot"></span>
                  </div>
                  <div className="exam-content">
                    <div className="exam-title">Mathematics Exam - Question 5</div>
                    <div className="exam-text">User has multiple apps open on protected layer</div>
                  </div>
                  
                  <div className="hidden-window">
                    <div className="hidden-window-title">
                      🌐 Chrome
                    </div>
                    <div style={{fontSize: '0.75rem', color: '#10B981'}}>Researching answers...</div>
                  </div>
                  
                  <div className="hidden-window" style={{top: '140px', right: '230px', width: '180px'}}>
                    <div className="hidden-window-title">
                      💬 Telegram
                    </div>
                    <div style={{fontSize: '0.75rem', color: '#10B981'}}>Chatting with friends</div>
                  </div>
                </div>

                <div className="activity-list">
                  <div className="activity-item">
                    <span className="activity-icon">🌐</span>
                    <div className="activity-text">
                      <div className="activity-label">Browser Active</div>
                      <div className="activity-status">Completely invisible</div>
                    </div>
                  </div>
                  <div className="activity-item">
                    <span className="activity-icon">💬</span>
                    <div className="activity-text">
                      <div className="activity-label">Messenger Open</div>
                      <div className="activity-status">Undetected</div>
                    </div>
                  </div>
                  <div className="activity-item">
                    <span className="activity-icon">🖱️</span>
                    <div className="activity-text">
                      <div className="activity-label">Multi-window Control</div>
                      <div className="activity-status">Full freedom</div>
                    </div>
                  </div>
                  <div className="activity-item">
                    <span className="activity-icon">🎮</span>
                    <div className="activity-text">
                      <div className="activity-label">Any Application</div>
                      <div className="activity-status">Available</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Bypass Features */}
        <section className="architecture-section">
          <h2 className="section-title">Bypassed Protection Mechanisms</h2>
          
          <div className="bypass-features">
            <div className="feature-card">
              <div className="feature-icon-box">🎯</div>
              <h3 className="feature-title">Focus Detection</h3>
              <p className="feature-desc">Alt+Tab and window switching completely invisible to proctor</p>
              <span className="feature-status">Bypassed</span>
            </div>

            <div className="feature-card">
              <div className="feature-icon-box">📸</div>
              <h3 className="feature-title">Screen Capture & Recording</h3>
              <p className="feature-desc">Protected layer invisible to all screenshot and screencast mechanisms</p>
              <span className="feature-status">Bypassed</span>
            </div>

            <div className="feature-card">
              <div className="feature-icon-box">📱</div>
              <h3 className="feature-title">Application Tracking</h3>
              <p className="feature-desc">Process list and running apps hidden from detection</p>
              <span className="feature-status">Bypassed</span>
            </div>

            <div className="feature-card">
              <div className="feature-icon-box">🖱️</div>
              <h3 className="feature-title">Mouse Monitoring</h3>
              <p className="feature-desc">Cursor movements in protected windows are invisible</p>
              <span className="feature-status">Bypassed</span>
            </div>

            <div className="feature-card">
              <div className="feature-icon-box">🔌</div>
              <h3 className="feature-title">API Interception</h3>
              <p className="feature-desc">Browser API calls intercepted and substituted</p>
              <span className="feature-status">Active</span>
            </div>

            <div className="feature-card">
              <div className="feature-icon-box">🛡️</div>
              <h3 className="feature-title">Protected Screen Layer</h3>
              <p className="feature-desc">Windows-level overlay invisible to capture tools</p>
              <span className="feature-status">Active</span>
            </div>
          </div>
        </section>

        {/* Configuration Panel */}
        <section className="config-section">
          <h2 className="config-title">User Configuration Interface</h2>
          
          <div className="config-grid">
            <div className="config-item">
              <div className="config-label">Window Positioning</div>
              <p className="config-desc">Configure exact coordinates, size, and position of hidden windows on screen</p>
            </div>

            <div className="config-item">
              <div className="config-label">Application Whitelist</div>
              <p className="config-desc">Select which apps can be opened invisibly (browsers, messengers, calculators)</p>
            </div>

            <div className="config-item">
              <div className="config-label">Hotkey Configuration</div>
              <p className="config-desc">Set custom keyboard shortcuts for quick switching between hidden windows</p>
            </div>

            <div className="config-item">
              <div className="config-label">Opacity Control</div>
              <p className="config-desc">Adjust transparency of protected layer windows for optimal visibility</p>
            </div>

            <div className="config-item">
              <div className="config-label">Multi-Monitor Support</div>
              <p className="config-desc">Extend protected layer across multiple displays if available</p>
            </div>

            <div className="config-item">
              <div className="config-label">Auto-Hide Rules</div>
              <p className="config-desc">Automatic hiding behavior based on proctor activity detection</p>
            </div>
          </div>
        </section>

        {/* Footer */}
        <div className="footer-banner">
          <p className="footer-text">Complete Bypass Solution for Maximum Security Assessment</p>
        </div>
      </div>
    </div>
  );
};

export default ProctorBypass;
